import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { Typography, AppBar, IconButton, Toolbar } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import {
  isMobile,
  isBrowser
} from 'react-device-detect'

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  dialogHeight: {
    maxHeight: `calc(100% - 2px)`
  },
  appBar: {
    //position: "static",
    backgroundColor: "#c3272e !important"
  },
  dialogPaper: {
    margin: isMobile ? '20px' : '32px',
    width: isMobile ? 'calc(100% - 40px)' : '80%',
    maxWidth: isMobile ? 'calc(100% - 40px)' : '800px',
    maxHeight: isMobile ? 'calc(100% - 40px)' : 'calc(100% - 64px)',
    overflow: 'hidden',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('sm')]: {
      margin: '20px',
      width: 'calc(100% - 40px)',
      maxWidth: 'calc(100% - 40px)',
      maxHeight: 'calc(100% - 40px)',
      overflow: 'hidden',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
    }
  },
  dialogContent: {
    padding: isMobile ? '8px' : '16px',
    overflow: 'auto',
    overflowY: 'scroll',
    maxHeight: isMobile ? 'calc(100vh - 80px)' : 'calc(100vh - 120px)',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '100%',
    boxSizing: 'border-box',
    '& *': {
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& input': {
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
    },
    '& textarea': {
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
      resize: 'vertical',
    },
    '& .MuiInputBase-root': {
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
    },
    '& .MuiInputBase-input': {
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box',
    }
  }
});
class CommentDialogCard extends React.Component {
  state = {
    open: false,
    scroll: "body"
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onOpenCommentsClick();
  };

  render() {
    const { classes, opendialog, fullScreen } = this.props;
    
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        classes={{ paper: classes.dialogPaper }}
        maxWidth={false}
        fullWidth={isMobile}
      >
        {/* {window.innerWidth >= 425 ? null : (
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close"
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6" color="inherit">
                Viewing Post
              </Typography>
            </Toolbar>
          </AppBar>
        )} */}

        <div className={classes.dialogContent}>
          {this.props.render(this.state, this.handleClose)}
        </div>
      </Dialog>
    );
  }
}


CommentDialogCard.propTypes = {
  classes: PropTypes.object.isRequired
};

const commentDialogStyled = withStyles(styles)(CommentDialogCard);
export default commentDialogStyled;
// export default CommentDialogCard;
